export const getWebPlatformUrl = (rawUrl: string): string => {
  const pos = rawUrl.search('://');
  if (pos >= 0) {
    return rawUrl.replace(rawUrl.slice(0, pos + 3), '/');
  }
  return rawUrl;
};
